import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { http, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Settings() {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ name: user.name, slug: user.slug, bio: user.bio || "", website: user.website || "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await http.put("/me/profile", f);
      setUser(data);
      setF({ ...f, slug: data.slug });
      toast.success("Profile saved");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} className="max-w-2xl mx-auto px-6 pt-14 space-y-7" data-testid="settings-page">
      <div>
        <p className="label-mono">Author profile</p>
        <h1 className="font-display text-5xl tracking-tight mt-2">How readers meet you.</h1>
        <p className="mt-3 text-[#5C584E]">Shown on your public author page: <Link to={`/a/${user.slug}`} className="border-b border-[#121210]" data-testid="settings-author-page-link">/a/{user.slug}</Link></p>
      </div>
      <label className="block"><span className="label-mono">Pen name</span><input className="input-paper mt-2 font-display text-xl" required value={f.name} onChange={set("name")} data-testid="settings-name-input" /></label>
      <label className="block"><span className="label-mono">Profile link</span>
        <div className="flex items-center mt-2"><span className="font-type text-sm text-[#8E8879] pr-2">/a/</span><input className="input-paper" required value={f.slug} onChange={set("slug")} data-testid="settings-slug-input" /></div>
      </label>
      <label className="block"><span className="label-mono">Bio</span><textarea rows={6} className="input-paper mt-2" value={f.bio} onChange={set("bio")} placeholder="Tip: paste the bio from your launch kit." data-testid="settings-bio-input" /></label>
      <label className="block"><span className="label-mono">Website</span><input type="url" className="input-paper mt-2" value={f.website} onChange={set("website")} placeholder="https://" data-testid="settings-website-input" /></label>
      <button className="btn-primary" disabled={busy} data-testid="settings-save-button">{busy ? "Saving…" : "Save profile"}</button>
    </form>
  );
}
